import { useCallback } from 'react'
import { ModalSmallCentered, ButtonsModalSmallCentered } from '../../../../../../../../../../baseComponents/Modal'
import { RowData } from '../../../../../../../../../../baseComponents/TwinTable/types'
import TwinTrans from '../../../../../../../../../../baseComponents/TwinTrans'
import { SetEditDeleteModalTy } from '../../../../../../../../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalSkipOperateStockSellTicketProps extends ModalSkipOperateStockSellTicketLogicProps {
}

const ModalSkipOperateStockSellTicket: React.FC<ModalSkipOperateStockSellTicketProps> = ({ setOpenModal, ...rest }) => {
    const { t } = useTwinTranslation()
    const { handleOnAccept } = useModalSkipOperateStockSellTicketLogic({ setOpenModal, ...rest })
    const renderThis: JSX.Element[] = []
    if (rest?.allRowData?.stockErrors) {
        for (const element of rest.allRowData.stockErrors) {
            const nLine = element.agentError.split('-')[1]
            renderThis.push(<StockLine reference={element.reference} nLine={nLine} />)
        }
    }
    return (
        <ModalSmallCentered opened={true} setOpened={() => setOpenModal(null)} className='flex_height'>
            <h2 className='mb-20'><TwinTrans transKey={'theFollowingProductsReferencesAreOutOfStock'}>No se han encontrado en el almacén las referencias de los productos siguientes:</TwinTrans></h2>
            {renderThis}
            <span className='my-20'><TwinTrans transKey={'continueTheProcessAnyway'}>¿Quieres continuar con el proceso igualmente?</TwinTrans></span>
            <ButtonsModalSmallCentered confirmText={t('accept', 'Aceptar')} setOpened={() => { }} onAccept={handleOnAccept} onCancel={() => setOpenModal(null)}/>
        </ModalSmallCentered>
    )
}

interface ModalSkipOperateStockSellTicketLogicProps {
    allRowData?: RowData
    setOpenModal: SetEditDeleteModalTy
}

const useModalSkipOperateStockSellTicketLogic = ({ allRowData, setOpenModal }: ModalSkipOperateStockSellTicketLogicProps) => {
    const handleOnAccept = useCallback(async () => {
        const myExtraProps = { ...allRowData?.extraProps, skipCheckOperateStock: true }
        setOpenModal({type: 'create', allRowData: myExtraProps})
    }, [allRowData, setOpenModal])

    return { handleOnAccept }
}

interface StockLineProps {
    reference: string
    nLine: string
}

const StockLine: React.FC<StockLineProps> = ({ reference, nLine }) => {
    return (
        <div className='w-300 mx-auto'>
            <TwinTrans transKey={'line'}>Línea</TwinTrans>
            <span> {nLine} </span>
            <span> - </span>
            <TwinTrans transKey={'productWithReference'}>Producto con referencia</TwinTrans>
            <span> {reference} </span>
        </div>
    )
}




export default ModalSkipOperateStockSellTicket